import { Component, ElementRef, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import * as jQuery from 'jquery';
import * as _ from 'underscore';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import { ColorConfig, DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import { ChartConfig } from '../../../analytics-core/interfaces/chart.interface';
import { SocialDemographComponent } from '../social-demograph/social-demograph.component';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';

@Component({
	selector: 'app-social-demographics-v3',
	styleUrls: ['./social-demographics-v3.component.css'],
	templateUrl: './social-demographics-v3.component.html'
})
export class SocialDemographicsV3Component extends SocialDemographComponent implements OnInit, WidgetCore, OnDestroy {
	overallCompletionData: any[];
	demographicOverview: any = {};
	@Input() key: string;
	@Input() sectiontitle: string;
	@Input() sectionclass: string;
	@Input() colors: string;
	@Input() colorsconfig: any;
	@Input() legend: any;
	@Input() placeholderimage: any;

	@ViewChild('graphArea') graphElement: ElementRef;

	public colorPalette: ColorPalette;
	public hasGraphData = true;
	public graphData: any;
	public graphs = [0, 1, 2];
	public creativeData: any = {};
	public creativeArray: any = {};
	public currentGraphData = [];
	public sortedCreatives: any = [];
	public categories: any = [];
	public graphSeriesData: any;
	public reloadSubscription;
	public showLoad = false;
	public hasData: boolean = false;
	public svgWidth;
	public svgHeight = 200;
	public selectedLegend;
	public partnerColors: string[] = [];
	public currentIndex = 0;
	public downloadconfig: any;
	public downloadConfiguration: DownloadConfig;
	protected chartConfig: ChartConfig;

	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		super();
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
	}
	ngOnInit(): void {
		this.legend = JSON.parse(decodeURI(this.legend));
		this.colorsconfig = JSON.parse(decodeURI(this.colorsconfig));
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
		this.selectedLegend = this.legend[0].value;
		this.processLegendData();
		this.requestData();
		this.partnerColors = this.colors.split(',');
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
	}
	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
	}
	processLegendData(): void {
		for (const legendObj of this.legend) {
			legendObj['selected'] = false;
		}
		this.legend[0].selected = true;
	}
	requestData(): void {
		this.hasData = true;
		this.showLoad = true;
		this.analyticsService.processCustomServiceRequest(this.key).subscribe((response: any) => {
			this.showLoad = false;
			if (response.success && response.data.length) {
				this.hasData = true;
				this.creativeData = response.data;
				this.processResponseData();
			} else {
				this.hasData = false;
			}
		});
	}
	processResponseData(): void {
		const genderGroup = _.groupBy(this.creativeData, (item: any) => item.gender);
		let index = 0;
		for (const key in genderGroup) {
			this.legend.forEach((legend: any) => {
				const legengValue = legend.value;
				this.creativeArray[legengValue] = _.groupBy(this.creativeData, (d: any) => d.gender);
				const keysOfEachLegend = Object.keys(this.creativeArray[legengValue]);
				keysOfEachLegend.forEach((currentKey) => {
					const sortedValuesAtKey = this.getSortedArraybyKeys(
						_.groupBy(this.creativeArray[legengValue][currentKey], (d: any) => d.age_group)
					);
					this.creativeArray[legengValue][currentKey]['categories'] = Object.keys(sortedValuesAtKey);
					this.creativeArray[legengValue][currentKey][legengValue] = _.reduce(
						this.getSumofLegends(sortedValuesAtKey, legengValue),
						(m, n) => m + n
					);
					this.creativeArray[legengValue][currentKey]['series'] = {
						name: `${currentKey.charAt(0).toUpperCase()}${currentKey.substring(1)} | ${this.creativeArray[legengValue][
							currentKey
						][legengValue].toLocaleString('en')}`,
						data: this.getSumofLegends(sortedValuesAtKey, legengValue),
						events: {
							legendItemClick: () => false // disable legend click
						}
					};
				});
			});
			this.getCurrentGraphObject(index);
			index++;
		}
	}

	updateNumberFormat(array) {
		let arr = array.map((num) => num.toLocaleString('en'));
		return array;
	}

	getCurrentGraphObject(index: any): void {
		let data = this.creativeArray[this.selectedLegend];
		let fArray = [];
		for (let key in data) {
			let obj = {};
			obj['name'] = key;
			obj['categories'] = data[key].categories;
			obj['series'] = data[key].series;
			obj['totalImpressions'] = data[key].impressions;
			obj['totalClicks'] = data[key].clicks;
			obj['totalEngagements'] = data[key].engagements;
			obj['color'] = this.getColorFromColorConfig(this.currentIndex);
			fArray.push(obj);
		}
		this.currentGraphData = fArray;
	}
	getSumofLegends(arr, val) {
		let data = [];
		Object.keys(arr).forEach(function (key) {
			let imp = _.reduce(
				arr[key],
				function (sum, value: any) {
					return Number(sum) + Number(value[val]);
				},
				0
			);
			data.push(imp);
		});
		return data;
	}
	getSortedArraybyKeys(object) {
		let result = [];
		_.forEach(Object.keys(object).sort(), function (key) {
			result[key] = object[key];
		});
		return result;
	}
	processSelectedLegendItem(legendItem) {
		this.showLoad = true;
		this.selectedLegend = legendItem.value;
		this.graphSeriesData = [];
		for (const legendObj of this.legend) {
			legendObj.selected = false;
		}
		const selectedLegend: any = _.findWhere(this.legend, { value: legendItem.value });
		this.currentIndex = _.findIndex(this.legend, (item: any) => this.selectedLegend == item.value);
		selectedLegend.selected = true;
		this.getCurrentGraphObject(this.currentIndex);
		this.showLoad = false;
	}

	chartHover(eventObj) {
		const index = eventObj.index;
		const shouldToggle = eventObj.toggle;
		const carouselItemsDiv = jQuery('.' + this.sectionclass + ' .carousel-points-container');
		const liele = jQuery(carouselItemsDiv).find('li');
		for (const ele of liele) {
			jQuery(ele).removeClass('hoverEffect');
		}
		if (index !== -1) {
			const selectedEle = jQuery(liele)[index];
			if (shouldToggle) {
				jQuery(selectedEle).addClass('hoverEffect');
			}
		}
	}

	getPercentage(type, data) {
		let total = _.pluck(this.currentGraphData, type).reduce((a, b) => a + b, 0);
		const percentage = (data / total) * 100;
		return { width: `${Math.floor(percentage)}%` };
	}
	getColorFromColorConfig(index: number, opacity?: number) {
		const colorConfig: ColorConfig = this.colorsconfig[index];
		const fillOpacity = opacity ? opacity : colorConfig.opacity;
		let rgb = '';
		if (colorConfig.isHex) {
			rgb = this.colorUtilityService.getRGBByOpacity(colorConfig.color, fillOpacity);
		} else {
			rgb = this.colorUtilityService.getRGBByColorType(this.colorPalette, colorConfig.color, fillOpacity);
		}
		return rgb;
	}
	downloadCSV(e) {
		e.preventDefault();
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.csvQueryKey ? this.downloadConfiguration.csvQueryKey : this.key,
			this.downloadConfiguration.fileName
		);
	}
}
